// extracted by mini-css-extract-plugin
module.exports = {"form":"CreateSignatorForm_form__aAfrZ","cols2":"CreateSignatorForm_cols2__en05j"};